import * as React from 'react';
import * as formUtils from '../../utils/form-utils';
import {Button} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import locales from '../../locales';
import {ButtonType} from "antd/es/button";


interface SubmitCancelFormItemProps {
  onSubmit: () => void;
  onCancel: () => void;
  disabled?: boolean;
  submitButtonType?: ButtonType;
  submitLabel?: string;
  cancelLabel?: string;
}

class SubmitCancelFormItem extends React.Component<SubmitCancelFormItemProps, {}> {
  public render(): React.ReactNode {
    const {onSubmit, onCancel, disabled, submitButtonType, submitLabel, cancelLabel} = this.props;
    const type = submitButtonType || "primary";
    return (
      <FormItem {...formUtils.tailFormItemLayout}>
        <Button type={type} onClick={onSubmit} disabled={disabled}>{submitLabel || locales.save}</Button>
        <Button style={{marginLeft: 8}} onClick={onCancel}
                disabled={disabled}>{cancelLabel || locales.cancel}</Button>
        {this.props.children}
      </FormItem>
    );
  }
}

export default SubmitCancelFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/SubmitCancelFormItem.tsx